import React, { Component } from 'react';
import * as util from '../../../../utils/EnumMapping';
import MainTable from '../../../common/table/MainTable';
import NewTax from './NewTax';
import TaxAggregatePanel from './TaxAggregatePanel';
import * as columns from './TaxColumns';

class Tax extends Component {

    enrich = (data) => {
        data.map((item) => {
            item.rowType = "TAX";
            item.paymentMethodLabel = util.getLabel(util.outPaymentMethods, item.paymentMethod);
            item.stateLabel = util.getLabel(util.states, item.state);
            return item;
        })
        return data;
    }

    render() {
        return (
            <MainTable
                divClassName="tax"
                tableName="Előírások"
                newObjectLabel="Új előírás hozzáadása"
                path='/api/taxes'
                enrich={this.enrich}
                columns={(refresh) => columns.columns(refresh)}
                dialogContent={(refresh, close) => <NewTax refresh={refresh} close={close} />}
                needAggregate={true}
                aggregatePanel={(rows) => <TaxAggregatePanel rows={rows} />} />
        );
    }
}

export default Tax;